import React, { useState, useEffect } from 'react';
import { FaTimes, FaFacebookF, FaTwitter, FaYoutube, FaLinkedinIn, FaArrowRight, FaStar, FaLocationDot, FaSearch } from 'react-icons/fa';
import HeroCarousel from '../productcarousal';
import { QueryButton } from '../../querybutton';
import ServicesSection from './exploreservices';
import FunFactsSection from './counter';
import TestimonialCarousel from './testimonials';
import BlogSection from './blogs';
import InteriorCarousel from '../interiorcarausal';
import BannerWithSideImages from './topsliderbanner';
import StepsCarousel from './stepcarausel';
import BannerWithSideImagesMobile from './mobilebanner';

const categories = {
  'Building & Hardware': {
    'Building Supplies': [
      {
        name: 'Concrete Products, Prefabricated Concrete Support Structures',
        image: 'assets/productimages/concreteproducts.jpg',
        use: 'Structural support in construction'
      },
      {
        name: 'Driveway & Porcelain Paving',
        image: 'assets/productimages/paving.jpg',
        use: 'Exterior flooring solutions'
      },
      {
        name: 'Block Paving, Pavement Blocks',
        image: 'assets/productimages/paving2.jpg',
        use: 'Driveway and pavement materials'
      },
      {
        name: 'Frost And Water Proofers',
        image: 'assets/productimages/frost.jpg',
        use: 'Weather protection for construction'
      },
      {
        name: 'Roofing Tiles',
        image: 'assets/productimages/rooftiles.jpg',
        use: 'Roof coverings for buildings'
      },
      {
        name: 'Guttering & Drainage',
        image: 'assets/productimages/guttering.jpg',
        use: 'Water management systems for roofs'
      },
      {
        name: 'Marble Slabs, Stones and Tiles',
        image: 'assets/productimages/marbles.jpg',
        use: 'Decorative and functional stone surfaces'
      },
      {
        name: 'Decorative & Rocky Stones',
        image: 'assets/productimages/stones.jpg',
        use: 'Landscaping and decorative elements'
      },
      {
        name: 'Waterproof & Weather Resistant Cement',
        image: 'assets/productimages/cement.jpg',
        use: 'Specialized construction materials'
      }
    ],
    'Facades and Fencing': [
      {
        name: 'Window Handles, Fasteners & Stays',
        image: 'assets/productimages/windowhandles.jpg',
        use: 'Window hardware components'
      },
      {
        name: 'Doors for Home and Industry - Internal',
        image: 'assets/productimages/door.webp',
        use: 'Internal access solutions'
      },
      {
        name: 'Doors for Home and Industry - External',
        image: 'assets/productimages/externaldoors.jpg',
        use: 'External access solutions'
      },
      {
        name: 'Doors for Home and Industry - Security Doors',
        image: 'assets/productimages/securitydoor.jpg',
        use: 'Enhanced security access'
      },
      {
        name: 'Doors for Home and Industry - Fire Rated Doors',
        image: 'assets/productimages/firerateddoor.jpg',
        use: 'Fire safety solutions'
      },
      {
        name: 'Doors for Home and Industry - Industrial Doors',
        image: 'assets/productimages/commercialdoors.jpg',
        use: 'Industrial access solutions'
      },
      {
        name: 'Windows - Wooden',
        image: 'assets/productimages/woodenwindow.jpg',
        use: 'Wooden window solutions'
      },
      {
        name: 'Windows - uPVC',
        image: 'assets/productimages/pvcwindow.jpg',
        use: 'uPVC window solutions'
      },
      {
        name: 'Windows - Aluminium',
        image: 'assets/productimages/aluminiumwindow.jpg',
        use: 'Aluminium window solutions'
      },
      {
        name: 'Panel Fencing',
        image: 'assets/productimages/panelfencing.jpg',
        use: 'Boundary and privacy fencing solutions'
      }
    ],
    'Timber and Sheet Materials': [
      {
        name: 'Plywood',
        image: 'assets/productimages/plywood.jpg',
        use: 'Versatile wood panel product'
      },
      {
        name: 'PVC Ceiling Panels',
        image: 'assets/productimages/plywoodceiling.jpg',
        use: 'Ceiling covering solutions'
      }
    ]
  },
  'Kitchen and Bathroom': {
    'Bathroom and Plumbing': [
      {
        name: 'Wastes Traps & Overflow and Kitchen Sinks Accessories',
        image: 'assets/productimages/plumbing.jpg',
        use: 'Plumbing system components'
      },
      {
        name: 'Pipes, Plumbing Supplies',
        image: 'assets/productimages/plumbing2.jpg',
        use: 'Essential plumbing materials'
      },
      {
        name: 'Bathroom Decorations And Accessories',
        image: 'assets/productimages/bathroomaccessories.png',
        use: 'Enhancing bathroom aesthetics'
      },
      {
        name: 'Bathroom Showers, Cubicles And Accessories',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Shower solutions'
      },
      {
        name: 'Shower Curtains',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Bathroom privacy solutions'
      },
      {
        name: 'Towels',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Bathroom essentials'
      },
      {
        name: 'Basins',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Bathroom fixtures'
      },
      {
        name: 'Toilet Seats',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Bathroom components'
      },
      {
        name: 'Tap Fittings and Spares',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Plumbing fixtures'
      },
      {
        name: 'Push Fit Waste Fittings',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Plumbing connections'
      },
      {
        name: 'Bath, Basins & Sink Fittings',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Fixture installations'
      },
      {
        name: 'Toilet Repair & Fittings',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Toilet maintenance'
      },
      {
        name: 'Wet Rooms',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Modern bathroom solutions'
      },
      {
        name: 'Shower Trays',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Shower base components'
      },
      {
        name: 'Shower Screens',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Shower enclosures'
      }
    ],
    'Bathroom Suite': [
      {
        name: 'Wall Hung Toilet',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Space-saving toilet solution'
      },
      {
        name: 'Freestanding Baths and Home Spa',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Luxury bathing solutions'
      },
      {
        name: 'Shower Baths',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Combination bathing solutions'
      },
      {
        name: 'Bath Screens',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Bath protection'
      }
    ],
    'Kitchen Appliances': [
      {
        name: 'Cooker',
        image: 'assets/productimages/cooker.jpg',
        use: 'Essential kitchen cooking appliance'
      },
      {
        name: 'Kitchen Sinks, Stainless Steel Sinks',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Kitchen work surfaces'
      },
      {
        name: 'Hand Mixers',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Food preparation tools'
      },
      {
        name: 'Blenders',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Food processing appliances'
      },
      {
        name: 'Freezer',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Food preservation'
      },
      {
        name: 'Fridge Freezer',
        image: 'assets/productimages/fridge.jpg',
        use: 'Food preservation and storage'
      },
      {
        name: 'Microwave',
        image: 'assets/productimages/microwave.jpg',
        use: 'Quick heating and cooking solutions'
      },
      {
        name: 'Rice Cooker',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Specialized cooking appliance'
      },
      {
        name: 'Refrigeration',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Cooling solutions'
      },
      {
        name: 'Kitchen cooker ovens',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Cooking appliances'
      },
      {
        name: 'Induction Hobs',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Modern cooking surfaces'
      },
      {
        name: 'Gas Hobs',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Traditional cooking surfaces'
      },
      {
        name: 'Cooker Hoods',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Kitchen ventilation'
      }
    ],
    'Kitchens': [
      {
        name: 'Kitchen Units And Cabinets',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Kitchen storage solutions'
      },
      {
        name: 'Complete Kitchen Units Supply',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Full kitchen solutions'
      },
      {
        name: 'Solid Wood Worktops Retail and Supply',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Kitchen surfaces'
      },
      {
        name: 'Laminate Worktops',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Durable kitchen surfaces'
      },
      {
        name: 'Kitchen Worktops and Surfaces',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Food preparation areas'
      },
      {
        name: 'Kitchen Flooring',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Kitchen floor solutions'
      },
      {
        name: 'Kitchen Cabinets Handles',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Cabinet hardware'
      },
      {
        name: 'Kitchen laundry',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Laundry solutions'
      }
    ]
  },
  'Home and Bedrooms': {
    'Home Furniture': [
      {
        name: 'Bed And Mattress',
        image: 'assets/productimages/bedmatresses.jpg',
        use: 'Comfortable sleeping solutions'
      },
      {
        name: 'Bedside Table',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Bedroom furniture'
      },
      {
        name: 'Sofa',
        image: 'assets/productimages/sofa.jpg',
        use: 'Seating for living rooms'
      },
      {
        name: 'Wardrobe',
        image: 'assets/productimages/wardrobe.jpg',
        use: 'Storage for clothing and accessories'
      }
    ],
    'Home Appliances': [
      {
        name: 'TVs',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Home entertainment'
      },
      {
        name: 'Washing Machines',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Laundry appliances'
      },
      {
        name: 'HI-FI Systems',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Audio systems'
      }
    ],
    'Home Furnishing': [
      {
        name: 'Wall Art And Pictures',
        image: 'assets/productimages/wallhanging.jpg',
        use: 'Decorative items for home interiors'
      },
      {
        name: 'Clocks And Home Accessories',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Home decoration'
      },
      {
        name: 'Curtain Pole Hanging Brackets',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Window treatment hardware'
      },
      {
        name: 'Curtain Tracks',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Window treatment systems'
      },
      {
        name: 'Curtain Poles & Tracks',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Window dressing solutions'
      },
      {
        name: 'Curtains, Blinds & Shutters',
        image: 'assets/productimages/curtains.jpg',
        use: 'Window coverings for privacy and light control'
      }
    ],
    'Cooking and Dining': [
      {
        name: 'Dinner Sets, Bowls, Cutlery and Dinner Plate Sets',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Tableware collections'
      },
      {
        name: 'Drinkware, drinking cups & wine glasses for Special Occasions',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Beverage serving solutions'
      },
      {
        name: 'Cookware, Saucepans, Frying Pans For Homes and Food Business',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Cooking utensils'
      }
    ]
  },
  'MEP (Mechanical, Electrical, and Plumbing)': {
    'Mechanical': [
      {
        name: 'Fans and Extractors',
        image: 'assets/productimages/fans.jpg',
        use: 'Air circulation systems'
      },
      {
        name: 'HVAC',
        image: 'assets/productimages/hvac.jpg',
        use: 'Heating, ventilation and air conditioning'
      },
      {
        name: 'Heaters',
        image: 'assets/productimages/heaters.jpg',
        use: 'Temperature control'
      },
      {
        name: 'Air Conditioners and Cooling Systems',
        image: 'assets/productimages/airconditioning.jpg',
        use: 'Climate control'
      },
      {
        name: 'Ventilators and grilles',
        image: 'assets/productimages/ventilatorsgrills.jpg',
        use: 'Air flow management'
      }
    ],
    'Electricals and Lighting': [
      {
        name: 'Standard Electrical Installation',
        image: 'assets/productimages/electricalinstallation.jpg',
        use: 'Basic electrical systems'
      },
      {
        name: 'Advanced Electrical Installation',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Specialized electrical systems'
      },
      {
        name: 'Connected Smart Installation',
        image: 'assets/productimages/smartinstallation.jpg',
        use: 'Smart home systems'
      },
      {
        name: 'Integrated Automation Systems',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Automated home solutions'
      },
      {
        name: 'Fixings & Plugs',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Electrical components'
      },
      {
        name: 'Fans',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Air circulation'
      },
      {
        name: 'Home Wiring Cables',
        image: 'assets/productimages/wiringcables.jpg',
        use: 'Electrical infrastructure'
      },
      {
        name: 'Standard Extension Leads',
        image: 'assets/productimages/extensionleads.jpg',
        use: 'Power distribution'
      },
      {
        name: 'Extension Leads, Cable Reels',
        image: 'assets/productimages/wiringcables.jpg',
        use: 'Flexible power solutions'
      },
      {
        name: 'Sockets, Plugs & Electrical Fittings',
        image: 'assets/productimages/socketplug2.jpg',
        use: 'Power access points'
      },
      {
        name: 'Lighting, Fixtures, And Fittings',
        image: 'assets/productimages/lightfixtures.webp',
        use: 'Illumination solutions'
      },
      {
        name: 'Cable Management',
        image: 'assets/productimages/cablemanagement.jpg',
        use: 'Wire organization'
      }
    ],
    'Lights': [
      {
        name: 'Indoor range - Downlights',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Ceiling lighting'
      },
      {
        name: 'Indoor range - Projectors',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Focused lighting'
      },
      {
        name: 'Indoor range - Ceiling',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Overhead lighting'
      },
      {
        name: 'Indoor range - Linear systems',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Strip lighting'
      },
      {
        name: 'Indoor range - Path markers',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Guidance lighting'
      },
      {
        name: 'Indoor range - Small spotlights',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Accent lighting'
      },
      {
        name: 'Indoor range - Small projectors',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Focused illumination'
      },
      {
        name: 'Indoor range - Environment care lighting',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Specialized lighting'
      },
      {
        name: 'Indoor range - Emergency',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Safety lighting'
      },
      {
        name: 'Outdoor range - Ceiling lamps',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Exterior lighting'
      },
      {
        name: 'Outdoor range - Wall lamps',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Wall-mounted lighting'
      },
      {
        name: 'Outdoor range - Wall path markers',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Exterior guidance lighting'
      },
      {
        name: 'Outdoor range - Uplights & inground lamps',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Landscape lighting'
      },
      {
        name: 'Outdoor range - Bollards & poles',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Pathway lighting'
      },
      {
        name: 'Outdoor range - Linear lights',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Strip lighting'
      },
      {
        name: 'Outdoor range - Accent lighting',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Decorative lighting'
      },
      {
        name: 'Outdoor range - Light effects',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Specialty lighting'
      },
      {
        name: 'Outdoor range - Underwater',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Pool lighting'
      },
      {
        name: 'Flex Light range - Flex light',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Flexible lighting'
      },
      {
        name: 'Electronic range - Electronics',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Lighting controls'
      },
      {
        name: 'Decorative Lights',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Aesthetic lighting'
      },
      {
        name: 'Streetlights',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Public lighting'
      }
    ],
    'Plumbing': [
      {
        name: 'Plumbing Systems',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Water distribution'
      }
    ]
  },
  'Tools and Equipments': {
    'Hand tools': [
      {
        name: 'Hammers, Crowbar\'s And Axes',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Demolition and construction tools'
      },
      {
        name: 'Screwdrivers',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Fastening tools'
      },
      {
        name: 'Chisels',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Carving and cutting tools'
      },
      {
        name: 'Wire Brushes',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Surface preparation tools'
      },
      {
        name: 'Breakers & Demolition Tools',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Demolition equipment'
      },
      {
        name: 'Tape Measure',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Measurement tools'
      },
      {
        name: 'Bricklaying Tools',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Masonry equipment'
      },
      {
        name: 'Nail Guns',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Fastening tools'
      },
      {
        name: 'Vice & Clamp',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Workholding tools'
      },
      {
        name: 'Hand Saws',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Cutting tools'
      },
      {
        name: 'Hex Keys',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Fastening tools'
      },
      {
        name: 'Electrical Tester',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Diagnostic tools'
      },
      {
        name: 'Soldering Iron',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Joining tools'
      },
      {
        name: 'Blow Torches',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Heating tools'
      }
    ],
    'Equipments': [
      {
        name: 'Brackets',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Support components'
      },
      {
        name: 'Nails',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Fastening components'
      },
      {
        name: 'Sandpaper',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Surface preparation'
      },
      {
        name: 'Workshop Machinery',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Industrial equipment'
      },
      {
        name: 'Sawing & Blades Drill Accessories',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Cutting accessories'
      },
      {
        name: 'Hole Saws',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Cutting tools'
      },
      {
        name: 'Ladders and Steps',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Access equipment'
      },
      {
        name: 'Step Ladders',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Access equipment'
      },
      {
        name: 'Step Stools, Step Ups Ladders',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Access equipment'
      },
      {
        name: 'Work Platforms',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Access equipment'
      }
    ],
    'Power Tools': [
      {
        name: 'Drills - Combi Drills',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Versatile drilling tools'
      },
      {
        name: 'Drills - Hammer Drills',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Masonry drilling tools'
      },
      {
        name: 'Drills - SDS Drills',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Specialty drilling tools'
      },
      {
        name: 'Drills - Angle Drills',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Specialty drilling tools'
      },
      {
        name: 'Saws - Circular Saws',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Cutting tools'
      },
      {
        name: 'Angle Grinders',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Cutting and grinding tools'
      },
      {
        name: 'Planers',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Surface preparation tools'
      },
      {
        name: 'Routers',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Woodworking tools'
      },
      {
        name: 'Sanders',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Surface preparation tools'
      },
      {
        name: 'Electric Screwdrivers',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Fastening tools'
      },
      {
        name: 'Impact Drivers & Wrenches',
        image: 'assets/productimages/placeholder.jpg',
        use: 'High-torque fastening tools'
      }
    ],
    'Power Tools Accessories': [
      {
        name: 'Drilling Sets',
        image: 'assets/productimages/drillingsets.webp',
        use: 'Drill bit collections'
      },
      {
        name: 'Drilling Bits',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Drill components'
      },
      {
        name: 'Screwdriver Bits',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Fastening accessories'
      },
      {
        name: 'Power & Accessories',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Tool components'
      },
      {
        name: 'Jigsaw Blade',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Cutting accessories'
      },
      {
        name: 'Wood Drill Bits',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Specialty drilling accessories'
      },
      {
        name: 'Specialist Drill Bits & Accessories',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Specialized drilling components'
      },
      {
        name: 'Core Drill Bits',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Hollow drilling accessories'
      }
    ],
    'Tiling Tools and Accessories': [
      {
        name: 'Tile Spacer',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Tiling installation tools'
      },
      {
        name: 'Tile Cutter',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Tile cutting tools'
      },
      {
        name: 'Tiling Tools',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Tile installation equipment'
      }
    ],
    'Measure and Level Tools': [
      {
        name: 'Tape Measure',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Measurement tools'
      },
      {
        name: 'Spirit Levels',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Leveling tools'
      },
      {
        name: 'Laser Levels',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Precision leveling tools'
      },
      {
        name: 'Measure Level Tools',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Measurement equipment'
      }
    ]
  },
  'Outdoor, Garden and Public Space': {
    'Outdoor and Garden': [
      {
        name: 'Garden Power Tools',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Outdoor maintenance equipment'
      },
      {
        name: 'Garden Furniture',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Outdoor seating solutions'
      },
      {
        name: 'Garden Dining Set',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Outdoor dining solutions'
      },
      {
        name: 'Garden Sofa',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Outdoor relaxation'
      },
      {
        name: 'Garden Furniture, Chairs, Sofas and Patio Sets',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Complete outdoor solutions'
      }
    ]
  },
  'Tiling and Flooring': {
    'Flooring': [
      {
        name: 'Laminate Flooring',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Durable floor covering'
      },
      {
        name: 'Real Wood Top Layer Flooring',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Premium floor covering'
      },
      {
        name: 'Epoxy Flooring',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Industrial floor coating'
      }
    ],
    'Tiles': [
      {
        name: 'Vinyl Flooring',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Versatile floor covering'
      },
      {
        name: 'Vinyl Floating Flooring',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Easy-install floor covering'
      },
      {
        name: 'Carpet Tiles',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Soft floor covering'
      },
      {
        name: 'Floor Tiles',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Hard floor covering'
      },
      {
        name: 'Wall Cladding',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Wall covering'
      },
      {
        name: 'Decorative Wall and Floor Tiles',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Aesthetic surface covering'
      },
      {
        name: 'Patterned Tiles',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Decorative surface covering'
      },
      {
        name: 'Mosaic Wall and Floor Tiles',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Artistic surface covering'
      },
      {
        name: 'Porcelain Tiles',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Durable surface covering'
      },
      {
        name: 'Grout',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Tile installation material'
      },
      {
        name: 'Architectural Ceramics',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Specialty surface covering'
      }
    ],
    'Accessories and Tools': [
      {
        name: 'Flooring and Tiling Supplies',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Installation materials'
      },
      {
        name: 'Tiling Adhesives',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Tile installation materials'
      },
      {
        name: 'Tile Sealants',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Tile protection'
      },
      {
        name: 'Scotias and Floor Trims',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Floor finishing'
      },
      {
        name: 'PVC Cladding',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Wall covering'
      },
      {
        name: 'Grouts',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Tile installation materials'
      }
    ]
  },
  'Painting and Decoration': {
    'Paint and Wood treatment': [
      {
        name: 'Paint',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Surface coating'
      },
      {
        name: 'Masonry Paint',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Exterior wall coating'
      },
      {
        name: 'Interior Emulsion Paint',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Wall coating'
      },
      {
        name: 'Metal Paint',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Metal surface coating'
      },
      {
        name: 'Spray Paint',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Specialty coating'
      },
      {
        name: 'Specialist Paint & Treatment',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Specialized coatings'
      },
      {
        name: 'Primers & Undercoats',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Surface preparation'
      },
      {
        name: 'Paint Solvents and Thinners',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Paint preparation'
      },
      {
        name: 'Marine Coats',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Water-resistant coatings'
      },
      {
        name: 'Surface preparation and Pre-treatments',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Coating preparation'
      }
    ],
    'Decorating Tools and Supplies': [
      {
        name: 'Paint Brushes & Sprayers',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Application tools'
      },
      {
        name: 'Tapes',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Masking materials'
      },
      {
        name: 'Paint Rollers',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Application tools'
      },
      {
        name: 'Knives & Scrappers',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Surface preparation tools'
      },
      {
        name: 'Knives & Cutters',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Cutting tools'
      },
      {
        name: 'Scuttles',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Paint containers'
      },
      {
        name: 'Paint Rollers, Pads, Sleeves, Trays & Poles',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Application tools'
      }
    ]
  },
  'Ceiling and Claddings': {
    'Ceiling Solutions': [
      {
        name: 'Plaster Products',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Ceiling materials'
      },
      {
        name: 'Plasterboard',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Ceiling panels'
      },
      {
        name: 'Plasterboard Fixing and Screws',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Installation components'
      },
      {
        name: 'POP or White Cement',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Ceiling finishing'
      },
      {
        name: 'Ceiling Tiles',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Ceiling covering'
      }
    ]
  },
  'Screws, Nails and Fittings': {
    'Screws': [
      {
        name: 'Screws Trade Packs',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Bulk fasteners'
      },
      {
        name: 'Wood Screws',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Wood fasteners'
      },
      {
        name: 'Decking Screws',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Outdoor wood fasteners'
      },
      {
        name: 'Timber Screws',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Wood construction fasteners'
      },
      {
        name: 'Drywall Screws',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Plasterboard fasteners'
      },
      {
        name: 'Stainless Steel Screws',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Corrosion-resistant fasteners'
      },
      {
        name: 'Self -Tapping and Drilling Screws',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Specialty fasteners'
      },
      {
        name: 'Masonry, Concrete Screws',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Hard material fasteners'
      },
      {
        name: 'Machine Screws',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Precision fasteners'
      },
      {
        name: 'Electrical Screws',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Electrical component fasteners'
      },
      {
        name: 'Security Screws',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Tamper-resistant fasteners'
      },
      {
        name: 'Flooring Screws',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Floor fasteners'
      },
      {
        name: 'Screws Caps',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Fastener covers'
      }
    ],
    'Fixers and Fasteners': [
      {
        name: 'Wall Plugs',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Wall anchors'
      },
      {
        name: 'Frame and Hammer Fixings',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Structural fasteners'
      },
      {
        name: 'Heavy Duty Screw Fixings & Rivets',
        image: 'assets/productimages/placeholder.jpg',
        use: 'High-strength fasteners'
      },
      {
        name: 'Hooks & Eyes fixings',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Hanging solutions'
      },
      {
        name: 'Parkers and Shims Fixings',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Alignment components'
      },
      {
        name: 'Plasterboard Fixings',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Drywall anchors'
      },
      {
        name: 'Resin Fixings',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Chemical anchors'
      },
      {
        name: 'Cavity Fixings',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Hollow wall anchors'
      },
      {
        name: 'Hose and Tool Clips',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Fastening components'
      },
      {
        name: 'Mirrors and Picture Fittings',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Hanging systems'
      }
    ],
    'Nails': [
      {
        name: 'Bright Nails',
        image: 'assets/productimages/placeholder.jpg',
        use: 'General purpose fasteners'
      },
      {
        name: 'Galvanised Nails',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Corrosion-resistant fasteners'
      },
      {
        name: 'Masonry Nails',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Hard material fasteners'
      },
      {
        name: 'Collated Nails',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Automated fastening'
      }
    ],
    'Accessories': [
      {
        name: 'Iron Mongery and Hardwares - Door Handles',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Door hardware'
      },
      {
        name: 'Iron Mongery and Hardwares - Hinges and Bolts',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Door hardware'
      }
    ]
  },
  'Finishes and Decoration Solutions': {
    'Interior and Exterior': [
      {
        name: 'INTERIOR',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Indoor finishing solutions'
      },
      {
        name: 'EXTERIOR',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Outdoor finishing solutions'
      }
    ],
    'Technical and Decorative Profiles': [
      {
        name: 'Decorative listels',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Architectural detailing'
      },
      {
        name: 'Corner and Edge Protection',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Surface protection'
      },
      {
        name: 'Skirtings',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Wall-floor transitions'
      },
      {
        name: 'Flooring Separations',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Floor transitions'
      },
      {
        name: 'Stair nosing',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Stair safety'
      },
      {
        name: 'Sanitary and Health Establishment',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Healthcare solutions'
      },
      {
        name: 'Facades and terraces',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Exterior solutions'
      }
    ],
    'Expansion Joints': [
      {
        name: 'Movement Joint Profiles',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Structural movement solutions'
      },
      {
        name: 'Structural Joints',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Building component connections'
      },
      {
        name: 'Cover plates',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Joint covers'
      },
      {
        name: 'Fire Barrier Systems',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Fire protection'
      },
      {
        name: 'Retracting joints',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Structural movement solutions'
      }
    ],
    'Technical Entrance Mats': [
      {
        name: 'Novomat Customized Name Plate',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Branded entrance solutions'
      },
      {
        name: 'Novomat Custom made',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Custom entrance solutions'
      },
      {
        name: 'Novomat Slimm (Kit)',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Low-profile entrance solutions'
      },
      {
        name: 'Novomat for walls (Kit)',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Wall-mounted entrance solutions'
      }
    ],
    'Universal Accessibility and Safety': [
      {
        name: 'Podotactile System of Universal Accessibility',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Tactile guidance systems'
      },
      {
        name: 'Non-slip solution',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Safety flooring'
      },
      {
        name: 'Solutions for height - Photoluminescent Solutions',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Emergency wayfinding'
      }
    ],
    'Construction Chemicals and Solutions': [
      {
        name: 'Waterproofing',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Moisture protection'
      },
      {
        name: 'Sealants',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Gap filling'
      },
      {
        name: 'Concrete Admixtures',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Concrete enhancement'
      },
      {
        name: 'Adhesives',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Bonding solutions'
      },
      {
        name: 'Coating',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Surface protection'
      },
      {
        name: 'Polymer Bonding Agents',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Material bonding'
      },
      {
        name: 'Repair and Rehabilitation',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Structural repair'
      },
      {
        name: 'Concrete Curing Compounds',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Concrete treatment'
      },
      {
        name: 'Retarder',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Concrete setting control'
      },
      {
        name: 'Accelerators',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Concrete setting control'
      },
      {
        name: 'Mortar additives',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Mortar enhancement'
      },
      {
        name: 'Mould releasing agents',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Formwork treatment'
      },
      {
        name: 'Concrete hardeners',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Surface hardening'
      },
      {
        name: 'Plasticizers',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Concrete workability'
      },
      {
        name: 'Flooring compounds',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Floor preparation'
      },
      {
        name: 'Superplasticizers',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Concrete workability'
      },
      {
        name: 'Cementitious materials',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Binding materials'
      },
      {
        name: 'Epoxy',
        image: 'assets/productimages/placeholder.jpg',
        use: 'High-strength bonding'
      },
      {
        name: 'Air-entraining',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Concrete enhancement'
      },
      {
        name: 'Green Construction Chemicals',
        image: 'assets/productimages/placeholder.jpg',
        use: 'Eco-friendly solutions'
      }
    ]
  }
};

const OmanyePage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Auto-rotate banner slides
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev === 2 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, []);


  const bannerSlides = [
    {
      image: "assets/bannerhome/banner1.jpg",
      title: "Build Your Dream Project with Us Today!",
      text: "From residential to commercial spaces, we bring your vision to life with unmatched craftsmanship and attention to detail."
    },
    {
      image: "assets/bannerhome/banner2.webp",
      title: "Let Us Help You Build Extraordinary!",
      text: "Our team blends innovation and expertise to deliver modern, sustainable, and long-lasting construction solutions."
    },
    {
      image: "assets/bannerhome/banner3.webp",
      title: "Start Building Your Project Today!",
      text: "Partner with us for seamless project execution, transparent processes, and a commitment to excellence from start to finish."
    }
  ];


  const funFacts = [
    { icon: "01", count: 1200, text: "Over 1,000 projects successfully delivered, from residential homes to large developments..." },
    { icon: "02", count: 85, text: "85% of clients return for future projects, demonstrating our commitment to quality..." },
    { icon: "03", count: 20, text: "Consistent 20% annual revenue growth over the past five years, reflecting our expanding..." }
  ];

  const services = [
    {
      id: 1,
      icon: "04",
      title: "Residential Construction",
      text: "We specialize in building durable and modern homes, blending innovative design with high-quality materials to create living spaces that truly feel like home."
    },
    {
      id: 2,
      icon: "05",
      title: "Interior Finishing",
      text: "Our interior finishing services focus on fine details, ensuring that every space is stylish, comfortable, and tailored to reflect your personal taste and lifestyle."
    },
    {
      id: 3,
      icon: "06",
      title: "Project Management",
      text: "From planning to execution, we handle every phase of your project with precision and efficiency, ensuring timely delivery and complete client satisfaction."
    },
    {
      id: 4,
      icon: "11",
      title: "Renovation & Remodeling",
      text: "We bring new life to existing spaces through creative renovation and remodeling solutions, improving both functionality and aesthetic appeal."
    },
  ];


  const projects = [
    { id: 1, image: "02", title: "Azila Mansion", type: "Luxury Residences, Modern Homes", location: "Dubai Marina", price: "From $290k", client: "RC Builders", year: "15 Oct 2019", duration: "5Y, 3M" },
    { id: 2, image: "03", title: "Azila Mansion", type: "Luxury Residences, Modern Homes", location: "Dubai Marina", price: "From $290k", client: "RC Builders", year: "15 Oct 2019", duration: "5Y, 3M" },
    { id: 3, image: "04", title: "Azila Mansion", type: "Luxury Residences, Modern Homes", location: "Dubai Marina", price: "From $290k", client: "RC Builders", year: "15 Oct 2019", duration: "5Y, 3M" }
  ];

  const teamMembers = [
    { id: 1, image: "01", name: "Henry George", position: "Safety Officer", text: "Highly skilled and experienced construction expert, known for his deep expertise in managing large-scale construction projects" },
    { id: 2, image: "02", name: "Thomas Bryant", position: "Civil Engineer", text: "Highly skilled and experienced construction expert, known for his deep expertise in managing large-scale construction projects" },
    { id: 3, image: "03", name: "Benjamin Clarke", position: "Project Coordinator", text: "Highly skilled and experienced construction expert, known for his deep expertise in managing large-scale construction projects" }
  ];





  const brands = ["01", "02", "03", "04", "05", "06"];

  return (

    <>



      <div className="font-sans text-gray-800 overflow-x-hidden">
        {/* Sidebar */}
        <div className={`fixed top-0 right-0 h-full w-96 bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out ${isSidebarOpen ? 'translate-x-0' : 'translate-x-full'}`}>
          <button onClick={toggleSidebar} className="absolute top-4 right-4 text-gray-600 hover:text-gray-900">
            <FaTimes className="text-2xl" />
          </button>

          <div className="p-6  flex flex-col">
            <div className="mb-8">
              <div className="thumbnail mb-4">
                <img src="assets/images/banner/04.jpg" alt="elevate" className="w-full h-48 object-cover rounded" />
              </div>
              <div className="content">
                <h4 className="text-xl font-bold mb-2">We Build Building and Great Constructive Homes.</h4>
                <p className="text-gray-600 mb-4">
                  We successfully cope with tasks of varying complexity, provide long-term guarantees and regularly
                  master new technologies.
                </p>
                <div className="footer mt-6">
                  <h4 className="text-lg font-semibold mb-2">Got a project in mind?</h4>
                  <a href="#contact" className="inline-block bg-[#00A3A1] text-white px-6 py-2 rounded hover:bg-blue-700 transition">Let's talk</a>
                </div>
              </div>
            </div>

            <div className="mobile-menu mt-auto">
              <nav className="mb-8">
                <ul className="space-y-4">
                  <li><a href="#" className="block hover:text-blue-600">Home</a></li>
                  <li><a href="#about" className="block hover:text-blue-600">About</a></li>
                  <li><a href="#service" className="block hover:text-blue-600">Services</a></li>
                  <li><a href="#project" className="block hover:text-blue-600">Projects</a></li>
                  <li><a href="#team" className="block hover:text-blue-600">Team</a></li>
                  <li><a href="#blog" className="block hover:text-blue-600">Blog</a></li>
                  <li><a href="#footer" className="block hover:text-blue-600">Contact Us</a></li>
                </ul>
              </nav>

              <div className="social-wrapper">
                <ul className="flex space-x-4">
                  <li><a href="#" className="text-gray-600 hover:text-blue-600"><FaFacebookF /></a></li>
                  <li><a href="#" className="text-gray-600 hover:text-blue-600"><FaTwitter /></a></li>
                  <li><a href="#" className="text-gray-600 hover:text-blue-600"><FaYoutube /></a></li>
                  <li><a href="#" className="text-gray-600 hover:text-blue-600"><FaLinkedinIn /></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <QueryButton />
        {/* Desktop & Tablet Banner */}
        <BannerWithSideImages />

        {/* Mobile Banner */}
        <BannerWithSideImagesMobile />


        {/* Banner Swiper */}
        {/* <div className="relative h-screen">
          {bannerSlides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 bg-cover bg-center flex items-center transition-opacity duration-1000 ${activeSlide === index ? 'opacity-' : 'opacity-0'}`}
              style={{ backgroundImage: `url(${slide.image})` }}          >
              <div className="container mx-auto px-4">
                <div className="max-w-2xl bg-white/60 backdrop-blur-sm p-6 rounded-xl shadow-lg">
                  <span className="text-gray-800 font-medium mb-2 block">
                    Building the better future
                  </span>
                  <h1 className="text-5xl font-bold text-[#00A3A1] mb-4">
                    {slide.title}
                  </h1>
                  <p className="text-gray-700 mb-6">{slide.text}</p>
                  <div className="button-wrapper">
                    <a
                      href="/our-services"
                      className="inline-flex items-center font-semibold bg-[#00A3A1] text-white px-6 py-3 rounded hover:bg-[#008b8a] transition"
                    >
                      Our Services
                      <img
                        src="assets/images/icons/arrow-up-right-1.svg"
                        alt="arrow"
                        className="ml-2 h-4"
                      />
                    </a>
                  </div>
                </div>

              </div>


            </div>
          ))}

          <div className="absolute bottom-8 left-0 right-0 flex justify-center space-x-2">
            {bannerSlides.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveSlide(index)}
                className={`w-3 h-3 rounded-full ${activeSlide === index ? 'bg-white' : 'bg-gray-400'}`}
              />
            ))}
          </div>
        </div> */}
        <InteriorCarousel />

        <ServicesSection />

        {/* <div className="mt-2">

          <HeroCarousel categories={categories} />
        </div> */}
        {/* Fun Facts */}


        <FunFactsSection />
        {/* <div className="py-8 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap -mx-4">
              {funFacts.map((fact, index) => (
                <div key={index} className="w-full md:w-1/3 px-4 mb-8">
                  <div className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow h-full">
                    <div className="icon mb-4">
                      <img src={`assets/images/service/${fact.icon}.svg`} alt="service" className="h-12" />
                    </div>
                    <h2 className="text-4xl font-bold mb-2">{fact.count}+</h2>
                    <p className="text-gray-600">{fact.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> */}

        <div className="py-12 bg-gray-900 text-white" id="about">
          <div className="container mx-auto px-4 md:px-8 lg:px-12">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-12">

              {/* Left Side Image + Stats */}
              <div className="w-full lg:w-5/12">
                <div className="relative">
                  <div className="overflow-hidden rounded-2xl shadow-lg">
                    <img
                      src="assets/productimages/delivery.jpg"
                      alt="Construction Work"
                      className="w-full h-[250px] md:h-[350px] lg:h-[400px] object-cover transform hover:scale-105 transition duration-500"
                    />
                  </div>

                  {/* Stats */}
                  <div className="flex mt-4 gap-4">
                    <div className="bg-[#00A3A1] p-4 md:p-6 rounded-xl text-center shadow-md flex-1">
                      <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold">500+</h2>
                      <span className="text-xs md:text-sm">Completed Projects</span>
                    </div>
                    <div className="bg-white text-gray-900 p-4 md:p-6 rounded-xl text-center shadow-md flex-1">
                      <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold">48+</h2>
                      <span className="text-xs md:text-sm">Awards Won</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Side Content */}
              <div className="w-full lg:w-6/12">
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold leading-snug mb-4">
                  Delivering Our Clients <span className="text-[#00A3A1]">Quality Construction</span>,
                  Clear Communication, and Lasting Value.
                </h2>
                <p className="text-gray-300 mb-3 md:mb-4 text-sm md:text-base leading-relaxed">
                  At our core, we focus on building strong foundations—both in our projects
                  and our client relationships. From residential to commercial developments,
                  we bring precision, innovation, and a commitment to excellence in every step.
                </p>
                <p className="text-gray-300 mb-6 md:mb-8 text-sm md:text-base leading-relaxed">
                  Our experienced team ensures transparency, timely delivery, and
                  cost-effective solutions. We believe in turning ideas into solid
                  structures that stand the test of time, creating spaces that inspire
                  and support growth.
                </p>

                <a
                  href="/about-us"
                  className="inline-flex items-center gap-2 bg-[#00A3A1] text-white px-5 py-2.5 md:px-6 md:py-3 rounded-lg shadow-md hover:bg-[#008c8a] transition text-sm md:text-base"
                >
                  Explore More
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 md:h-5 md:w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>



        {/* Marquee */}
        {/* <div className="bg-gray-900 py-4 overflow-hidden">
          <div className="marquee whitespace-nowrap">
            <span className="text-white text-xl font-bold mx-8">Premium Construction Theme&nbsp;</span>
            <span className="text-white text-xl font-bold mx-8">Premium Construction Theme&nbsp;</span>
            <span className="text-white text-xl font-bold mx-8">Premium Construction Theme&nbsp;</span>
            <span className="text-white text-xl font-bold mx-8">Premium Construction Theme&nbsp;</span>
          </div>
        </div> */}


        {/* Services */}
        <div className="py-8 bg-[#00A3A1] text-white" id="service">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <span className="text-white font-medium mb-2 block">What We Offer</span>
              <h2 className="text-4xl font-bold">Explore Our Services</h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pb-6">
              {services.map((service, index) => (
                <div
                  key={index}
                  className="bg-gray-800 p-3 rounded-lg h-full shadow-md hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="icon mb-3">
                    <img
                      src={`assets/images/service/${service.icon}.svg`}
                      alt="service"
                      className="h-8"
                    />
                  </div>
                  <div className="inner">
                    <h5 className="text-xl font-bold mb-2">{service.title}</h5>
                    <p className="text-gray-400">{service.text}</p>
                  </div>
                </div>
              ))}
            </div>


          </div>
        </div>

        {/* Why Choose Us */}

        <StepsCarousel />

        {/* Projects */}
        {/* <div className="py-16 bg-[#00A3A1] text-white" id="project">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <span className="text-white font-medium mb-2 block">Recent Projects</span>
              <h2 className="text-4xl font-bold">Our Completed Projects</h2>
            </div>

            <div className="flex flex-wrap pb-8 -mx-4">
              {projects.map((project, index) => (
                <div key={index} className="w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 px-4 mb-6">
                  <div className="bg-gray-800 rounded-lg overflow-hidden">
                    <a href="#project" className="thumbnail block">
                      <img src={`assets/images/portfolio/${project.image}.webp`} alt="" className="w-full h-64 object-cover" />
                    </a>
                    <div className="p-6">
                      <a href="#project">
                        <h2 className="text-2xl font-bold mb-2">{project.title}</h2>
                      </a>
                      <p className="text-gray-400 mb-2">{project.type}</p>
                      <a href="#project" className="text-gray-400 flex items-center mb-4">
                      </a>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <span className="text-gray-400 block">Price:</span>
                          <p>{project.price}</p>
                        </div>
                        <div>
                          <span className="text-gray-400 block">Client:</span>
                          <p>{project.client}</p>
                        </div>
                        <div>
                          <span className="text-gray-400 block">Project Year:</span>
                          <p>{project.year}</p>
                        </div>
                        <div>
                          <span className="text-gray-400 block">Duration:</span>
                          <p>{project.duration}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> */}

        {/* Team */}
        {/* <div className="py-16 bg-gray-900 text-white" id="team">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <span className="text-white font-medium mb-2 block">Expert Team Members</span>
              <h2 className="text-4xl font-bold">Meet The Awesome Team</h2>
            </div>

            <div className="flex flex-wrap -mx-4">
              <div className="w-full lg:w-6/12 px-4 mb-8">
                <div className="bg-gray-800 rounded-lg overflow-hidden flex flex-col lg:flex-row">
                  <a href="#team" className="thumbnail block lg:w-1/3">
                    <img src={`assets/images/team/01.webp`} alt="team" className="w-full h-full lg:h-full object-cover" />
                  </a>
                  <div className="p-6 lg:w-2/3">
                    <a href="#team">
                      <h3 className="text-2xl font-bold mb-2">Henry George</h3>
                    </a>
                    <span className="text-[#00A3A1] block mb-4">Safety Officer</span>
                    <p className="text-gray-400 mb-4">
                      Highly skilled and experienced construction expert, known for his deep expertise in
                      managing large-scale construction projects
                    </p>
                    <div className="social-area-wrapper flex space-x-4">
                      <a href="#" className="text-gray-400 hover:text-blue-400"><FaFacebookF /></a>
                      <a href="#" className="text-gray-400 hover:text-blue-400"><FaTwitter /></a>
                      <a href="#" className="text-gray-400 hover:text-blue-400"><FaLinkedinIn /></a>
                      <a href="#" className="text-gray-400 hover:text-blue-400"><FaYoutube /></a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="w-full lg:w-6/12 px-4">
                <div className="bg-gray-800 rounded-lg overflow-hidden mb-6 flex">
                  <a href="#team" className="thumbnail block w-1/3">
                    <img src={`assets/images/team/02.webp`} alt="team" className="w-full h-48 object-cover" />
                  </a>
                  <div className="p-6 w-2/3">
                    <a href="#team">
                      <h3 className="text-xl font-bold mb-2">Thomas Bryant</h3>
                    </a>
                    <span className="text-[#00A3A1] block mb-2">Civil Engineer</span>
                    <p className="text-gray-400 text-sm mb-2">
                      Highly skilled and experienced construction expert, known for his deep expertise in
                      managing large-scale construction projects
                    </p>
                    <div className="social-area-wrapper flex space-x-2">
                      <a href="#" className="text-gray-400 hover:text-blue-400 text-sm"><FaFacebookF /></a>
                      <a href="#" className="text-gray-400 hover:text-blue-400 text-sm"><FaTwitter /></a>
                      <a href="#" className="text-gray-400 hover:text-blue-400 text-sm"><FaLinkedinIn /></a>
                      <a href="#" className="text-gray-400 hover:text-blue-400 text-sm"><FaYoutube /></a>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-800 rounded-lg overflow-hidden flex">
                  <a href="#team" className="thumbnail block w-1/3">
                    <img src={`assets/images/team/03.webp`} alt="team" className="w-full h-48 object-cover" />
                  </a>
                  <div className="p-6 w-2/3">
                    <a href="#team">
                      <h3 className="text-xl font-bold mb-2">Benjamin Clarke</h3>
                    </a>
                    <span className="text-[#00A3A1] block mb-2">Project Coordinator</span>
                    <p className="text-gray-400 text-sm mb-2">
                      Highly skilled and experienced construction expert, known for his deep expertise in
                      managing large-scale construction projects
                    </p>
                    <div className="social-area-wrapper flex space-x-2">
                      <a href="#" className="text-gray-400 hover:text-blue-400 text-sm"><FaFacebookF /></a>
                      <a href="#" className="text-gray-400 hover:text-blue-400 text-sm"><FaTwitter /></a>
                      <a href="#" className="text-gray-400 hover:text-blue-400 text-sm"><FaLinkedinIn /></a>
                      <a href="#" className="text-gray-400 hover:text-blue-400 text-sm"><FaYoutube /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}


        <TestimonialCarousel />

        {/* CTA */}
        <div className="bg-[#00A3A1] text-white">
          <div className="container mx-auto px-4 py-10">
            <div className="flex flex-col lg:flex-row items-center lg:items-stretch">

              {/* Image Section */}
              <div className="w-full lg:w-5/12">
                <div className="thumbnail h-64 sm:h-80 lg:h-full">
                  <img
                    src="assets/images/cta/dreams.jpg"
                    alt="service"
                    className="w-full h-full object-cover rounded-lg shadow-lg"
                  />
                </div>
              </div>

              {/* Text Section */}
              <div className="w-full lg:w-7/12 p-6 sm:p-10 lg:p-12 flex items-center">
                <div className="inner text-center lg:text-left">
                  <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-snug">
                    Ready to Build Your Dream? <br />
                    Schedule Your Consultation Today!
                  </h2>

                  {/* Buttons */}
                  <div className="button-wrapper mt-6 flex flex-col sm:flex-row justify-center lg:justify-start gap-3">
                    <a
                      href="/about-us"
                      className="inline-block bg-white text-gray-900 px-3 w-auto py-1 rounded-lg font-medium hover:bg-gray-100 transition shadow"
                    >
                      More About Us
                    </a>
                    <a
                      href="/turnkey-projects"
                      className="inline-block bg-white text-gray-900 px-3 w-auto py-1 rounded-lg font-medium hover:bg-gray-100 transition shadow"
                    >
                      Our Services
                    </a>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>



        <BlogSection />

        {/* Brands */}
        {/* <div className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex overflow-x-auto space-x-12 items-center py-4">
            {brands.map((brand, index) => (
              <div key={index} className="flex-shrink-0">
                <img src={`assets/images/brand/${brand}.svg`} alt="brand" className="h-12 opacity-60 hover:opacity-100 transition" />
              </div>
            ))}
          </div>
        </div>
      </div> */}

        {/* Footer */}
        {/* <footer className="py-12 bg-gray-900 text-white" id="footer">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap -mx-4">
            <div className="w-full md:w-1/4 px-4 mb-8">
              <h3 className="text-xl font-bold mb-4">About Us</h3>
              <p className="text-gray-400 mb-4">
                We are dedicated to building structures that last and relationships that endure, with a focus on quality, precision, and innovation.
              </p>
              <div className="social flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white"><FaFacebookF /></a>
                <a href="#" className="text-gray-400 hover:text-white"><FaTwitter /></a>
                <a href="#" className="text-gray-400 hover:text-white"><FaYoutube /></a>
                <a href="#" className="text-gray-400 hover:text-white"><FaLinkedinIn /></a>
              </div>
            </div>

            <div className="w-full md:w-1/4 px-4 mb-8">
              <h3 className="text-xl font-bold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li><a href="#" className="text-gray-400 hover:text-white">Home</a></li>
                <li><a href="#about" className="text-gray-400 hover:text-white">About Us</a></li>
                <li><a href="#service" className="text-gray-400 hover:text-white">Services</a></li>
                <li><a href="#project" className="text-gray-400 hover:text-white">Projects</a></li>
                <li><a href="#blog" className="text-gray-400 hover:text-white">Blog</a></li>
              </ul>
            </div>

            <div className="w-full md:w-1/4 px-4 mb-8">
              <h3 className="text-xl font-bold mb-4">Services</h3>
              <ul className="space-y-2">
                <li><a href="#service" className="text-gray-400 hover:text-white">Residential Construction</a></li>
                <li><a href="#service" className="text-gray-400 hover:text-white">Interior Finishing</a></li>
                <li><a href="#service" className="text-gray-400 hover:text-white">Project Management</a></li>
                <li><a href="#service" className="text-gray-400 hover:text-white">Commercial Construction</a></li>
                <li><a href="#service" className="text-gray-400 hover:text-white">Renovation</a></li>
              </ul>
            </div>

            <div className="w-full md:w-1/4 px-4 mb-8">
              <h3 className="text-xl font-bold mb-4">Contact Us</h3>
              <address className="text-gray-400 not-italic">
                <p className="mb-2">123 Construction Street</p>
                <p className="mb-2">Building City, BC 12345</p>
                <p className="mb-2">Phone: (123) 456-7890</p>
                <p className="mb-2">Email: info@omanye.com</p>
              </address>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 mt-8 text-center text-gray-400">
            <p>&copy; {new Date().getFullYear()} OMANYE FZ -LLC. All Rights Reserved.</p>
          </div>
        </div>
      </footer> */}

        {/* Mobile Menu Button */}
        {/* <button
          onClick={toggleSidebar}
          className="fixed bottom-8 right-8 bg-[#00A3A1] text-white rounded-full w-16 h-16 flex items-center justify-center shadow-lg lg:hidden"
        >
          <span className="sr-only">Open Menu</span>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button> */}
      </div>

    </>
  );
};

export default OmanyePage;